
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052B4","d":"M0 0h513v342H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M513 33L95.3 171 513 310.76v30.57L0 171 513 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M513 287.18v24.58L81.72 171 513 30v24.16"}}),_c('path',{attrs:{"fill":"#A2001D","d":"M476.98 140.21l-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"}}),_c('path',{attrs:{"fill":"#EFC100","stroke":"#231F20","stroke-miterlimit":"10","d":"M317.89 238.41l-22.24-11.11 22.24-11.11h144.46v22.22z"}})])
          )
        }
      }
    